                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Upload Assessment form
                        </label>
                        <div class="col-md-9">
                          <div [formGroup]="parentForm!">
                            <div class=" form-group">
                              <div *ngIf="data && data.length > 0">
                                <ul *ngFor="let document of data; let i=index">
                                  <li><a (click)="downloadFile(document.fileId)" href="javascript:void(0)">{{ document.name }}</a></li>
                                </ul>
                              </div>
                              <div formArrayName="documentDatas">
                                <div *ngFor="let file of documentDatas.controls; let i=index">
                                  <div class="row mb-1">
                                    <div class="col">
                                      <div [formGroupName]="i" class="custom-file">
                                        <input
                                          (change)="onFileChange($event, i)"
                                          [ngClass]="{'is-invalid': file!.invalid && (file!.dirty || file!.touched)}"
                                          accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xlsx,.xls,.zip"
                                          class="custom-file-input"
                                          type="file"
                                        />
                                        <label class="custom-file-label">{{ file.value.name }}</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-2">
                                <a
                                  href="{{ registerFormDoc?.downloadUrl}}"
                                  target="_blank">
                                  click here to download the assessment
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
